import './index.css';

export default {
  name: 'Apopconfirm',
  props: {
    confirmButtonText: { type: String, default: () => '确定' },
    cancelButtonText: { type: String, default: () => '取消' },
    icon: { type: String, default: () => 'el-icon-warning' },
    iconColor: { type: String, default: () => 'red' },
    title: { type: String, default: () => '确定要删除此记录吗?' },
    type: { type: String, default: () => 'danger' },
    label: { type: String, default: () => '删除' },
    text: { type: String, default: () => '删除' },
  },
  methods: {
    submit() { this.$emit('submit') },
    cancel() { this.$emit('cancel') },
  },
  render() {
    const { ...attrs } = this.$attrs;
    return (
      <div class="a-popconfirm">
        <el-popconfirm
          confirm-button-text={this.confirmButtonText}
          cancel-button-text={this.cancelButtonText}
          icon={this.icon}
          icon-color={this.iconColor}
          title={this.title}
          on-confirm={() => this.submit()}
          on-cancel={() => this.cancel()}
          {...{ attrs }}
        >
          {this.$slots.default ? (<span slot="reference">{this.$slots.default}</span>) : (<i slot="reference" class="el-icon-delete" />)}
        </el-popconfirm>
      </div>
    );
  }
}